import { Link } from "react-router-dom";
import {
  Upload, Printer, ForkKnife, MapPin, Users as UsersIcon, ClockCounterClockwise,
  Plus, Package as PackageIcon, BellRinging,
} from "@phosphor-icons/react";
import { useAuth } from "@/lib/auth";

export default function Admin() {
  const { user } = useAuth();
  const cards = [
    { to: "/admin/import", icon: Upload, label: "Import Center (Dry Goods & Meals)", desc: "Upload Excel / CSV with preview & validation", admin: true },
    { to: "/admin/add-meal", icon: Plus, label: "Add New Meal Record", desc: "Manual meal record entry" },
    { to: "/admin/add-dry-goods", icon: PackageIcon, label: "Add New Dry-Goods Item", desc: "Manual dry-goods entry" },
    { to: "/admin/notifications", icon: BellRinging, label: "Notifications", desc: "Role defaults, delivery mode, test send", admin: true },
    { to: "/admin/qr-print", icon: Printer, label: "QR Print", desc: "Generate & print QR labels in bulk" },
    { to: "/admin/meal-codes", icon: ForkKnife, label: "Meal & Diet Codes", desc: "Diet code conversion rules" },
    { to: "/admin/locations", icon: MapPin, label: "Locations", desc: "Bays, sub-locations, capacity" },
    { to: "/admin/users", icon: UsersIcon, label: "Users & Permissions", desc: "Create, edit, deactivate users", admin: true },
    { to: "/admin/audit", icon: ClockCounterClockwise, label: "Audit Log", desc: "All changes, corrections, imports", admin: true },
  ].filter((c) => !c.admin || user?.role === "admin" || user?.role === "system_owner");

  return (
    <div className="p-4 md:p-6">
      <div className="mb-6">
        <div className="label-tech mb-1">Backend</div>
        <h1 className="font-display font-black text-3xl md:text-4xl tracking-tight">Administration</h1>
        <p className="text-sm text-muted-foreground mt-1">Item & quantity configuration, imports, users, and audit trail.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {cards.map((c) => (
          <Link
            key={c.to}
            to={c.to}
            className="card-flat border-border p-4 hover:border-primary hover:bg-muted/40"
          >
            <c.icon size={22} weight="bold" className="text-primary mb-2" />
            <div className="font-display font-bold">{c.label}</div>
            <div className="text-xs text-muted-foreground mt-1">{c.desc}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
